import React,{ Component } from "react";
import { connect } from "react-redux";
import { getManagers, deleteManager,setManagerPageInfo } from "../../actions/actionManager";
import { Row, Col, Button, Modal, ModalHeader, ModalFooter, Card, CardBody, CardHeader } from "reactstrap";
import LoadingSpinner from "../../components/LoadingSpinner/index";
import { NotificationManager } from "react-notifications";
import "react-table/react-table.css";
import Proptypes from "prop-types";
import BreadCrumbCompo from "../../components/Breadcrumb/BreadCrumbCompo";
import DataTable from "../../components/Table/Table"

const routes = [
    {name: "Home",path:"/userdashboard",isActive: false},
    {name: "Manager",path:"/managers",isActive: true}
];

class Managers extends Component{
    constructor(props) {
        super(props);
                
        this.state = {
            modal: false,
            pages: 1,
            managerId: null,
        };

        this.deleteConfirm = this.deleteConfirm.bind(this);
        this.deleteManagerAction = this.deleteManagerAction.bind(this);
        this.cancelDelete = this.cancelDelete.bind(this);
        this.handleDeleteSuccess = this.handleDeleteSuccess.bind(this);
        this.handleDeleteError = this.handleDeleteError.bind(this);
    }

    componentDidMount(){
        this.props.getManagers();
    }

    deleteConfirm(managerId){
        this.setState({modal: !this.state.modal, managerId: managerId});
    }

    cancelDelete(){
        this.setState({modal: !this.state.modal}); 
    }

    deleteManagerAction(){
        this.props.deleteManager(this.state.managerId).
            then(() => this.handleDeleteSuccess()).
            catch(() => this.handleDeleteError());
    }

    handleDeleteSuccess(){
        const {deleteManagerErrorMessage} = this.props;
        if(deleteManagerErrorMessage) {
            NotificationManager.error(deleteManagerErrorMessage,"Delete Manager", 3000);
            this.setState({modal: false});
        }
        else{
            NotificationManager.success("Manager Deleted Successfully","Delete Manager", 3000);
            this.setState({modal: false});
            this.props.getManagers();
        }
    }

    handleDeleteError(){
        const {deleteManagerError} = this.props;
        if(deleteManagerError){
            NotificationManager.error(deleteManagerError,"Delete Manager", 3000);
            this.setState({modal: false});
        }
        else{
            NotificationManager.error("Delete Manager Failed","Delete User", 3000);
            this.setState({modal: false});
        }
    }

    render(){
        if (this.props.getManagersLoading){
            return (<div> <LoadingSpinner /></div>);
        }
        
        const { managers } = this.props;

        const columns = [
            {
                type: "text",
                name: "Hostname",
                accessor: "manager_hostname",
                filterable: true,
                sortable: true
            },
            {
                type: "text",
                name: "Last Reported",
                accessor: "last_reported_elapsed",
                filterable: false,
                sortable: true
            },
            {
                type: "text",
                name: "Zone",
                accessor: "zone_name",
                filterable: true,
                sortable: true
            },
            {
                type: "text",
                name: "Agents",
                accessor: "servers.length",
                filterable: true,
                sortable: true
            }
        ];

        const actions = [
            { id: "view", icon: "fa-eye", description: "View" },
            { id: "delete", icon: "fa-trash", description: "Delete" },
        ];

        const onAction = (action, item) => {
            switch (action) {
                case "view":
                    this.props.history.push(`/viewmanager/${item.manager_id}`);
                break;

                case "delete":
                    this.deleteConfirm(item.manager_id);
                break;
            }
        }

        return (
            <div className="profile-page">
                <BreadCrumbCompo routes={routes}/>    
                <Row>
                    <Col sm={{ size: 10, order: 3, offset: 1 }}>
                        <Card >
                            <CardHeader>
                            <div className="title-head">
                                <i className="fa fa-shield"></i> <strong>Managers</strong></div>
                            </CardHeader>
                            <CardBody className="p-0" >
                                <DataTable
                                    id="managers"
                                    data={managers}
                                    columns={columns}
                                    actions={actions}
                                    onAction={onAction}
                                />
                            </CardBody>
                        </Card>
                    </Col>
                </Row>


                <Modal isOpen={this.state.modal} toggle={this.cancelDelete} centered={true} className="user-modal">
                    <ModalHeader toggle={this.cancelDelete}>Are you sure you want to delete this Manager?
                    </ModalHeader>
                    <ModalFooter>
                        <Button onClick={this.cancelDelete} className="cancel-button" size="sm" color="basic">Close</Button>
                        <Button onClick={this.deleteManagerAction} className="delete-button" size="sm" color="danger">Delete</Button>
                    </ModalFooter>
                </Modal>
            </div>
        );
    }
}

Managers.propTypes = {
    getManagers: Proptypes.func.isRequired,
    deleteManager: Proptypes.func.isRequired,
    deleteManagerError: Proptypes.func,
    managers: Proptypes.array,
    getManagersLoading: Proptypes.bool,
    deleteManagerErrorMessage: Proptypes.func,
    className: Proptypes.func
};


export default connect(state => 
    ({
        managers: state.managers.managers || [],
        deleteManagerErrorMessage: state.managers.deleteManagerErrorMessage || null,
        getManagersLoading: state.managers.getManagersLoading || false,
        deleteManagerError: state.managers.deleteManagerError || null,
        pages : {pageSize : state.managers.pageSize, pageNo : state.managers.pageNo},
    }),
dispatch => 
    ({  
        getManagers: () => dispatch(getManagers()),
        deleteManager: (data) => dispatch(deleteManager(data)),
        setPageInfo : (data)=> dispatch(setManagerPageInfo(data)), 
    }))(Managers);
